module.exports = __webpack_public_path__ + "static/media/media.cd591053.png";